// Generated by CoffeeScript 2.7.0
var Member;

import Base from './base.js';

export default Member = class Member extends Base {};
